import Vue from 'vue'
import axios from 'axios/index'
import SQL from 'sql.js'
import getQuestionScore from './get-question score'

const sortQuestions = function (a, b) {
  let nameA = a.questionName.toUpperCase()
  let nameB = b.questionName.toUpperCase()
  if (nameA < nameB) {
    return -1
  }
  if (nameA > nameB) {
    return 1
  }
  // names must be equal
  return 0
}

function getQuartiles (rootGetters, gameData) {
  return axios({
    url: process.env.API_URL + `/ws/recall/quartiles/deck/${gameData.tagDeckId}/level/${gameData.level}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + rootGetters.token
    }
  })
}

function getNextTestSet (rootGetters, gameData) {
  return axios({
    url: process.env.API_URL + `/ws/recall/member/${gameData.memberId}/schedule/${gameData.scheduleId}/deck/${gameData.deckId}/level/${gameData.level}/testset/next`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + rootGetters.token
    }
  })
}

function createAssocArray (keys = [], values = []) {
  let resultArray = []
  for (let i = 0; i < values.length; i++) {
    let obj = {}
    for (let j = 0; j < keys.length; j++) {
      obj[keys[j]] = values[i][j]
    }
    resultArray.push(obj)
  }
  return (resultArray)
}

const recallCompleteTest = (commit, rootGetters, testId) => new Promise((resolve, reject) => {
  axios({
    url: process.env.API_URL + `/ws/recall/complete/test/${testId}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + rootGetters.token
    }
  }).then(response => {
    if (response) {
      resolve(response.data)
    } else {
      reject(Error('Recall Test set failed!'))
    }
  }).catch(error => {
    commit('flashError', error.message, { root: true })
  })
})

const getTestSet = (commit, rootGetters, gameData) => new Promise((resolve, reject) => {
  axios({
    url: process.env.API_URL + `/ws/recall/member/${gameData.memberId}/schedule/${gameData.scheduleId}/deck/${gameData.deckId}/level/${gameData.level}/testset`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + rootGetters.token
    }
  }).then(response => {
    if (response) {
      // TODO: uncomment following line
      if (response.data.completed !== null) {
      // const $flag = false
      // if ($flag === true) {
        getNextTestSet(rootGetters, gameData).then(response => {
          let questions = response.data.questions
          questions.sort(sortQuestions)
          response.data.questions = questions
          resolve(response.data)
        })
      } else {
        let questions = response.data.questions
        questions.sort(sortQuestions)
        response.data.questions = questions
        resolve(response.data)
      }
    } else {
      // console.log('Test set not found!')
      reject(Error('Test set not found!'))
    }
  }).catch(error => {
    getNextTestSet(rootGetters, gameData).then(response => {
      let questions = response.data.questions
      questions.sort(sortQuestions)
      response.data.questions = questions
      resolve(response.data)
    })
    console.log(error)
    // commit('flashError', 'Test set not found!' + error, { root: true })
  })
})

const state = {
  questions: [],
  testSetCompleted: null,
  testId: null,
  testScore: null,
  testsetId: null,
  testsetNumber: null,
  testsetSize: null,
  memberScores: [],
  tenQPopup: {},
  tenQPopupStatus: false,
  dialogCalculatingScoreStaus: false,
  currentScorePercent: 0,
  tokenUsedInQuestions: []
}

const getters = {
  getTenQPopup (state) {
    return state.tenQPopup
  },
  getTenQpopupStatus (state) {
    return state.tenQPopupStatus
  },
  getDialogCalculatingScoreStaus (state) {
    return state.dialogCalculatingScoreStaus
  },
  getQuizQuestions (state) {
    return state.questions
  },
  getTestsetId (state) {
    return state.testsetId
  },
  getMemberScores (state) {
    return state.memberScores
  },
  getCurrentScorePercent (state) {
    return state.currentScorePercent
  },
  getTokenUsedInQuestions (state) {
    return state.tokenUsedInQuestions
  }
}

const actions = {
  markTestSetComplete ({ dispatch, state, commit, rootGetters, rootState }, gdata) {
    commit('setRefreshHomePage', true, { root: true })
    // let $gid = gdata.groupId
    let $level = gdata.level
    let $fname = rootState.user.details.firstName
    let $tagDeckId = gdata.deckId
    // let $memberId = gdata.memberId
    // let $scheduleId = gdata.scheduleId
    let $testId = state.testId
    let $memberLevelResponse = rootState.course.levels
    // console.log('$testId', $testId)
    // console.log('Mark test set complete', $gid, $level, $tagDeckId, $fname, $memberId, $scheduleId, $testId, $memberLevelResponse)

    // let $lastSkillPercentage = Math.round($memberLevelResponse.find(level => level.id === $level).memberLevel.skillPercentage)
    // console.log('$lastSkillPercentage', $lastSkillPercentage)

    // if ($testId && state.testSetCompleted === null) {
    // console.log('TEST SET is in progress...(not MARKED as COMPLETED).')
    // console.log('memberScores.length', state.memberScores.length)
    // console.log('state.testsetSize', state.testsetSize)
    if (state.memberScores.length === state.testsetSize) {
      // console.log('TEST SET : All questions answered.')

      recallCompleteTest(commit, rootGetters, $testId).then($recall => {
        let $quartile = getQuartiles(rootGetters, {tagDeckId: $tagDeckId, level: $level})
        $quartile.then(response => {
          // console.log(response.data)
          let $levelUpCor = Math.round($memberLevelResponse.find(level => level.id === $level).level_up_cor)
          // console.log('$levelUpCor', $levelUpCor)
          let $lastLevel = $memberLevelResponse[0].id
          // console.log('$lastLevel', $lastLevel)

          let $levelAlreadyPlayed = []
          let $totalObtainedScore = 0
          let $totalScore = 0
          let $scoreInPercent = 0
          // console.log($levelAlreadyPlayed, $totalObtainedScore, $totalScore, $scoreInPercent)
          // get max poiint
          state.questions.forEach($question => {
            // console.log($question.scoreValue, $question.score.scoredValue)
            $totalScore += parseInt($question.scoreValue)
            $totalObtainedScore += parseInt($question.score.scoredValue)
          })

          $totalScore = $totalScore === 0 ? 1 : $totalScore
          $scoreInPercent = Math.round(($totalObtainedScore / $totalScore) * 100)

          let $arrayStmt1 = [
            `${$fname}, you scored ${$scoreInPercent}.`,
            `So you got ${$scoreInPercent}.`,
            `${$fname}, your total is ${$scoreInPercent}.`,
            `Your score is ${$scoreInPercent}.`
          ]

          let $arrayStmt2 = [
            'Excellent job!',
            'Very nice work.',
            'That\'s a good score.'
          ]

          let $arrayStmt3 = [
            'Stay with this.',
            'Give it another try.',
            'You should play again.',
            'Try one more time.',
            'You can do better.',
            'Stay focused.',
            'Keep it up.',
            'Give it another go.'
          ]
          /*   FIRST LINE  */
          let $secondPart = ''
          let key = Math.floor(Math.random() * $arrayStmt1.length)
          let key2 = Math.floor(Math.random() * $arrayStmt2.length)
          let key3 = Math.floor(Math.random() * $arrayStmt3.length)

          let $firstPart = $arrayStmt1[key]
          if (($scoreInPercent) > $quartile['upper']) {
            $secondPart = $arrayStmt2[key2]
          } else {
            $secondPart = $arrayStmt3[key3]
          }
          let $firstLine = $firstPart + ' ' + $secondPart

          /** ****** SECOND LINE ******* **/
          let $skillPercentage = 0
          let $coveragePercentage = 0

          // console.log('$recall->memberLevels', $recall['memberLevels'])
          if (typeof $recall['memberLevels'] !== 'undefined') {
            $recall['memberLevels'].forEach($memLevel => {
              // console.log('$memLevel', $memLevel)
              if ($memLevel['level'] === $level) {
                $skillPercentage = Math.floor($memLevel['skillPercentage'])
                $coveragePercentage = Math.floor($memLevel['coveragePercentage'])
              }
            })
          }
          $coveragePercentage = $coveragePercentage === 0 ? 1 : $coveragePercentage
          let $secondLine = `Your level skill is ${$skillPercentage}, based on your scores and ${$coveragePercentage}% coverage.`

          /** ***** Third line is levelUpText message or number of plays required for next level up. **/
          let $levelUpText = ''
          let $nextLevel = $level + 1
          let $PlaysRemaining = Math.ceil(($levelUpCor / $coveragePercentage))

          if ($level !== $lastLevel && $skillPercentage >= $levelUpCor) {
            $levelUpText = `You've reached the level-up goal. You can move to level ${$nextLevel}. Good job!`
          } else if ($level === $lastLevel && ((Math.floor($skillPercentage) >= $levelUpCor && $levelUpCor !== -1) ||
            (Math.floor($skillPercentage) >= 100 && $levelUpCor === -1))) {
            $levelUpText = `This is the last level, so repeat play keeps your recall skills sharp!`
          } else {
            if ($levelAlreadyPlayed.includes($nextLevel)) {
              $levelUpText = `You have already completed this level.`
            } else {
              if ($coveragePercentage < 90) {
                if ($PlaysRemaining === 1) {
                  $levelUpText = `You'll level up in about one more play at this level.`
                } else {
                  $levelUpText = `You'll level up in about ${$PlaysRemaining} more plays at this level.`
                }
              } else {
                $levelUpText = `You are close to the level-up goal. Try one more time!`
              }
            }
          }

          let $tenQpopUp = {
            'first_line': $firstLine,
            'second_line': $secondLine,
            'third_line': $levelUpText,
            'recall_skill_per': $skillPercentage, // level skill in progress bar
            'recall_coverage_per': $coveragePercentage,
            'level_up_cor': $levelUpCor,
            'total_obtained_score': $totalObtainedScore,
            'score_in_percent': $scoreInPercent
          }
          // console.log($tenQpopUp)
          commit('setDialogCalculatingScoreStaus', false)
          commit('setTenQpopup', $tenQpopUp)
        })
      })
    } else {
      Error('Can\'t call complete before completing all questions')
    }
    // }
  },

  validateAnswer ({ dispatch, state, commit, rootGetters }, gdata) {
    commit('setCurrentScorePercent')
    const score = getQuestionScore(gdata.question, gdata.answer)
    let scoreData = {
      score: {
        memberAnswers: score.memberAnswers,
        questionId: score.questionId,
        responseText: score.responseText,
        scoredValue: score.scoredValue
      },
      index: gdata.qIndex
    }
    commit('setQuizQuestionsScore', scoreData)
    commit('updateMemberScore', score)

    let postData = {
      'memberScores': [{
        memberAnswers: score.memberAnswers,
        questionId: score.questionId,
        responseText: score.responseText,
        scoredValue: score.scoredValue
      }]
    }
    const testSetId = state.testId
    axios({
      url: process.env.API_URL + `/ws/recall/putscore/test/${testSetId}`,
      method: 'POST',
      data: postData,
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      if (response) {
        dispatch('checkFor10QPopup', gdata)
        // console.log(response.data)
      } else {
        Error('Test set not found!')
      }
    }).catch(error => {
      commit('flashError', error.message, { root: true })
    })
  },

  checkFor10QPopup ({ dispatch, state, commit, rootGetters }, gameData) {
    // console.log('Checking for 10Q Popup', gameData)
    let completed = true
    state.questions.forEach(ques => {
      if (typeof ques.score.scoredValue === 'undefined') {
        completed = false
      }
    })
    if (completed === true) {
      commit('setDialogCalculatingScoreStaus', true)
      dispatch('markTestSetComplete', {
        groupId: gameData.groupId,
        level: gameData.level,
        deckId: gameData.deckId,
        memberId: gameData.memberId,
        scheduleId: gameData.scheduleId
      })
    }
    // console.log('completed', completed)
  },

  fetchTestSet ({ dispatch, state, commit, rootGetters }, gameData) {
    dispatch('connectDb', gameData.deckId, { root: true })
      .then(dbObject => {
        const db = new SQL.Database(dbObject)
        db.exec(`PRAGMA query_only = true;`)
        const getTestSetData = getTestSet(commit, rootGetters, gameData)
        // TODO: check user is in exam or not
        getTestSetData.then(testSetData => {
          // console.log('getTestSetData', testSetData)

          if (testSetData) {
            let questionsArr = []
            testSetData.questions.forEach(question => {
              // console.log(question)
              const questionId = question.questionId
              let contents = db.exec(`SELECT * FROM answers WHERE question_id = ${questionId}`)
              question.answers = createAssocArray(contents[0]['columns'], contents[0]['values'])

              let questionObj = db.exec(`SELECT * FROM questions WHERE question_id = ${questionId}`)
              const questionArr = createAssocArray(questionObj[0]['columns'], questionObj[0]['values'])
              const viewId = questionArr[0].view_id

              let resource = db.exec(`SELECT * FROM resources WHERE view_id = ${viewId}`)
              const resourceArr = createAssocArray(resource[0]['columns'], resource[0]['values'])
              question.textResource = resourceArr.find((resource) => resource.resource_type === 0)
              question.imageResource = resourceArr.find((resource) => resource.resource_type === 1)

              let qResource = db.exec(`SELECT * FROM resources WHERE view_id = ${question.viewId}`)
              const qResourceArr = createAssocArray(qResource[0]['columns'], qResource[0]['values'])
              question.peek_textResource = qResourceArr.find((resource) => resource.resource_type === 0)
              question.peek_imageResource = qResourceArr.find((resource) => resource.resource_type === 1)

              question.score = {}

              questionsArr.push(question)
            })
            commit('setQuizQuestions', questionsArr)
            commit('setTestsetDetails', testSetData)
            return testSetData
          } else {
            Error('Test set not found!')
          }
        }).then(testset => {
          // console.log('testset', testset)
          if (testset.testId !== null) {
            Error('Test ID not found !!')
          }

          // if (testset.completed === null) {
          // console.log('Getting Score')
          axios({
            url: process.env.API_URL + `/ws/recall/getscore/test/${testset.testId}`,
            method: 'GET',
            headers: {
              Authorization: 'Bearer ' + rootGetters.token
            }
          }).then(scores => {
            // console.log('Checking for recall..')
            // console.log(testset.testId)
            if (scores.data.memberScores.length === testset.questions.length) {
              // console.log('TEST SET : All questions answered.')
              recallCompleteTest(commit, rootGetters, testset.testId)
              // console.log(':: RECALLED COMPLETE  :: ')
            }
            commit('setMemberScores', scores.data.memberScores)
            scores.data.memberScores.forEach(score => {
              let index = state.questions.findIndex(ques => ques.questionId === score.questionId)
              commit('setQuizQuestionsScore', {score, index})
            })
            // console.log('setCurrentScorePercent...')
            commit('setCurrentScorePercent')
            return true
          })
          // } else {
          //   Error('Test set already conpleted!')
          // }
        }).catch(error => {
          commit('flashError', error.message, { root: true })
        })
      })
      .catch(err => {
        console.error(err)
      })
  },
  deductCoin ({ dispatch, state, commit, rootGetters }, gameData) {
    if (state.tokenUsedInQuestions.includes(gameData.questionId) === false && gameData.isAnswered === false) {
      commit('course/updateCoinCount', gameData.groupId, {root: true})
      // console.log('Deduct Coin')
      let data = {'memberId': gameData.memberId, 'scheduleId': gameData.scheduleId, 'tokens': gameData.tokens}
      axios({
        url: process.env.API_URL + `/ws/playerservice/scoring/redeemtokens/schedule/${gameData.scheduleId}/member/${gameData.memberId}/tokens/1`,
        method: 'POST',
        data,
        headers: {
          Authorization: 'Bearer ' + rootGetters.token
        }
      })
    }
    commit('setTokenUsedInQuestions', gameData.questionId)
  }
}

const mutations = {
  setTokenUsedInQuestions (state, questionId) {
    if (state.tokenUsedInQuestions.includes(questionId) === false) {
      state.tokenUsedInQuestions.push(questionId)
    }
  },
  setCurrentScorePercent (state) {
    let scoreValue = 0
    let scoredValue = 0
    state.questions.forEach(ques => {
      scoreValue += parseInt(ques.scoreValue)
      scoredValue += typeof ques.score.scoredValue !== 'undefined' ? parseInt(ques.score.scoredValue) : 0
    })
    // console.log('scoredValue:', scoreValue, scoredValue)
    state.currentScorePercent = Math.floor((scoredValue / scoreValue) * 100)
  },
  setMemberScores (state, data) {
    state.memberScores = data
  },
  updateMemberScore (state, data) {
    state.memberScores.push(data)
  },
  setQuizQuestionsScore (state, data) {
    state.questions[data.index].score = data.score
  },
  setQuizQuestions (state, data) {
    state.questions = data
  },
  setTestsetDetails (state, data) {
    state.testSetCompleted = data.completed
    state.testId = data.testId
    state.testScore = data.testScore
    state.testsetId = data.testsetId
    state.testsetNumber = data.testsetNumber
    state.testsetSize = data.testsetSize
  },
  setUserSelection (state, data) {
    let question = state.questions[data.qIndex]
    question.selectedAnswerIndex = parseInt(data.selectedAnswerIndex)
    question.correctIndex = parseInt(data.correctAnsIndex)
    question.selectedAnswerTxt = data.selectedAnswerTxt
    question.selectedAnswer = data.selectedAnswerTxt
    Vue.set(state.questions, data.qIndex, question)
  },
  setTenQpopup (state, data) {
    // console.log('setTenQpopup', data)
    state.tenQPopup = data
    state.tenQPopupStatus = true
  },
  setTenQpopupStatus (state, flag) {
    state.tenQPopupStatus = flag
  },
  setDialogCalculatingScoreStaus (state, flag) {
    state.dialogCalculatingScoreStaus = flag
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/quiz.js